import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.GridPlaceholder = class GridPlaceholder extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-grid-placeholder';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.$placeholder = this.$element;
    }

    addEventListeners() {
        $(window).on('content:updated', this.initGridPlaceholder.bind(this));
    }

    render() {
        this.setVars();
        this.addEventListeners();
        this.initGridPlaceholder();
    }

    initGridPlaceholder() {
        this.$target = $('[data-fa-placeholder-target]');
        if ($.trim($(this.$placeholder).html()).length) {
            this.$target.append(this.$placeholder);
        }
    }
};



// WEBPACK FOOTER //
// ./components/grid-placeholder/scripts/grid-placeholder.js